import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { OAuthModuleConfig, OAuthModule } from 'angular-oauth2-oidc';
import { authConfigFactory } from './app/factories/oauth-module-config.factory';
import { AppConfigService } from './app/services/app-config/app-config.service';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule
} from '@angular/material/dialog';
import { matDialogOptions } from './app/scss/material/mat-dialog.options';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_CONFIG } from './app/services/app-config/injector';

const configUrl = 'assets/config/app-config.json';

if (environment.production) {
  enableProdMode();
}
(async () => {
  // The no-cache directive does not prevent the storing of responses
  // but instead prevents the reuse of responses without revalidation.
  const response = await fetch(configUrl, { cache: 'no-cache' });
  const configObj = await response.json();
  // https://medium.com/better-programming/follow-up-how-to-handle-async-providers-in-angular-54957c7349c4
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        AppRoutingModule,
        OAuthModule.forRoot(),
        MatDialogModule
      ),
      {
        provide: OAuthModuleConfig,
        useFactory: authConfigFactory,
        deps: [AppConfigService]
      },
      { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: matDialogOptions },
      { provide: APP_CONFIG, useValue: configObj },
      provideHttpClient(withInterceptorsFromDi()),
      provideNoopAnimations()
    ]
  }).catch((err) => console.error(err));
})();
